import { getDatesBounds } from './get-dates-bounds';

const DATE_REGEX = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/;
export const parseDateIfValid = (dateStr: string | null) => {
    if (!dateStr) return null;
    const match = dateStr.match(DATE_REGEX);
    if (!match) return null;
    const date = new Date(`${match[3]}-${match[2].padStart(2, '0')}-${match[1].padStart(2, '0')}T00:00:00`);
    if (isNaN(Number(date))) {
        return null;
    }
    const { from, to } = getDatesBounds();
    if (date < from || date > to) {
        return null;
    }
    return date;
};
